/* @flow */
import gql from 'graphql-tag';
import type {FilterGroupType} from '../components/MoreFilters/MoreFilters';

type FilteredCountQueryResults = {
    filterGroups?: FilterGroupType[],
    resultCount: number
};

export type FilteredCountQueryResponseData = {
    results: FilteredCountQueryResults,
    error?: Error,
    loading: boolean
};

const commonSelectionSet = `
    id
    resultCount
    filterGroups {
        groupInfo {
            name
            id
        }
        filters {
            count
            checked
            filter {
                id
                name
                refineByQueryArgument
                description
            }
        }
    }
`;

export const fragments = {
    results: gql`
        fragment FilterCountsResults on Results {
            ${commonSelectionSet}
        }
    `,
    searchResult: gql`
        fragment FilterCountsSearchResult on SearchResult {
            ${commonSelectionSet}
        }
    `
};

export const FILTER_COUNT_QUERY_NAME = 'FilterCountQuery';
export const FILTER_COUNT_SEARCH_QUERY_NAME = 'SearchFilterCountQuery';

export const filteredCountQuery = gql`
    query ${FILTER_COUNT_QUERY_NAME}($params: ResultsParams) {
        results(params: $params) {
            ...FilterCountsResults
        }
    }
    ${fragments.results}
`;

export const filteredSearchCountQuery = gql`
    query ${FILTER_COUNT_SEARCH_QUERY_NAME}($request: SearchResultRequest!) {
        results: search(request: $request) {
            ...FilterCountsSearchResult
        }
    }
    ${fragments.searchResult}
`;
